import CompanyInformation from "../company-information";
import { translate } from "../utils/translations/translate";
import en_gb from "./en_gb";

global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/shared/translations/nl_nl.ts", "<global>"],fileName: "/shared/translations/nl_nl.ts",childLine: 5,line: "const nl_nl: typeof en_gb = {"});
const nl_nl: typeof en_gb = {
    backend: {
        errors: {
            default: {
                internalServerError: translate(
                    "Er is iets misgegaan aan onze kant. We werken eraan om het zo snel mogelijk op te lossen. Probeer het later opnieuw."
                ),
                clientSideError: translate(
                    "Er is iets misgegaan aan jouw kant. Controleer je invoer en probeer het opnieuw."
                ),
                serverOffline: translate(
                    "Onze servers zijn momenteel offline. We zijn op de hoogte van het probleem en werken aan een oplossing."
                ),
                notAuthorized: translate(
                    `U bent niet bevoegd om deze actie uit te voeren.`
                ),
                badRequest: translate(
                    `De aanvraag is niet in het juiste formaat.`
                )
            },
            backlogItemCategoryResolver: {
                addNewBacklogItemCategory: {
                    title: translate(`De title moet tussen de 1 en 256 karakters bevatten.`)
                }
            },
            backlogItemResolver: {
                item: {
                    notFound: translate(`Het backlog item kon niet gevonden worden.`)
                },
                getBacklogItems: {
                    notFound: translate(`De categorie kon niet gevonden worden.`)
                },
                addNewBacklogItem: {
                    title: translate(`De title moet tussen de 1 en 256 karakters bevatten.`),
                    noParent: translate(`De parent of categorie kon niet worden gevonden.`)
                }
            },
            userResolver: {
                authorize: {
                    wrongCombination: translate(
                        `Het emailadres en wachtwoord komen niet overeen.`
                    )
                },
                register: {
                    localeInvalid: translate(
                        `De geselecteerde taalinstelling "$locale" wordt niet ondersteund. Kies een geldige optie.`
                    ),
                    themeInvalid: translate(
                        `Het thema "$theme" is niet beschikbaar. Kies een ander thema.`
                    ),
                    agreeToTerms: translate(
                        "Om verder te gaan, moet je akkoord gaan met onze algemene voorwaarden en privacybeleid."
                    ),
                    emailInUse: translate(
                        "Dit e-mailadres is al geregistreerd. Probeer in te loggen of gebruik een ander e-mailadres."
                    ),
                    couldntGenerateSalt: translate(
                        "Er is een probleem opgetreden bij het beveiligen van je account. Probeer het opnieuw."
                    ),
                    couldntHashPassword: translate(
                        "We konden je wachtwoord op dit moment niet verwerken. Probeer het opnieuw."
                    ),
                    couldntSendMail: translate(
                        "We konden de e-mail niet verzenden vanwege een serverprobleem. Probeer het later opnieuw."
                    )
                }
            }
        }
    },    
    components: {
        router: {
            routeNotFound: translate('De route op pad "$route" kon niet worden gevonden.')
        }
    },
    document: {
        title: {
            main: translate(`${CompanyInformation.name}`),
            prefix: {
                login: {
                    forms: {
                        login: translate('Inloggen'),
                        register: translate('Registreren')
                    }
                }
            }
        }
    },
    emails: {
        templates: {
            activateYourAccount: {
                subject: translate(`Welkom bij ${CompanyInformation.name}`),
                template: {
                    title: translate(`Welkom bij ${CompanyInformation.name}`),
                    sections: {
                        one: {
                            paragraphs: {
                                one: translate(`Hi, $fullName! Welkom bij <b>${CompanyInformation.name}</b>! Om je registratie te voltooien, activeer je account.`),
                                two: translate(`Klik op de knop hieronder om je account te activeren en aan de slag te gaan met ons platform.`),
                            },
                            buttons: {
                                activateAccount: translate('Activeer Account')
                            }
                        }
                    }
                }
            },
        },
        alts: {
            callUs: translate('Bel ons'),
            mailUs: translate('Mail ons'),
            logo: translate('Logo'),
            icon: translate('Icoon')
        },
        footer: {
            copyright: translate('Copyright'),
            allRightsReserved: translate('Alle rechten voorbehouden.'),
        }
    },
    general: {
        greeting: translate('Hi'),
        modes: {
            dark: translate('donkere'),
            light: translate('lichte')
        }
    },
    locales: {
        nl_NL: translate('Nederlands'),
        en_GB: translate('Engels')
    },
    pages: {
        login: {
            forms: {
                login: {
                    title: translate("Inloggen"),
                    description: translate("Vul uw accountgegevens in om door te gaan"),
                    controls: {
                        email: {
                            label: translate('Email')
                        },
                        password: {
                            label: translate('Wachtwoord')
                        },
                        rememberMe: {
                            label: translate('Onthoud me')
                        },
                        forgotPassword: {
                            label: translate('Wachtwoord vergeten')
                        }
                    },
                    buttons: {
                        login: translate('Inloggen'),
                        or: translate('of'),
                        google: translate('Inloggen met Google')
                    },
                    register: {
                        label: translate('Nog niet geregistreerd?'),
                        button: translate('Maak een Account')
                    }
                },
                register: {
                    title: translate("Registreren"),
                    description: translate("Maak je appbeheer eenvoudig en leuk!"),
                    controls: {
                        fullName: {
                            label: translate("Volledige naam"),
                            placeholder: translate("Voer hier je volledige naam in")
                        },
                        email: {
                            label: translate("E-mail"),
                            placeholder: translate("Voer hier je e-mailadres in")
                        },
                        password: {
                            label: translate("Wachtwoord"),
                            placeholder: translate("Voer hier je wachtwoord in")
                        },
                        agreement: {
                            label: translate("Ik ga akkoord met de"),
                            privacyPolicy: translate("privacyverklaring"),
                            and: translate("en"),
                            terms: translate("voorwaarden")
                        }
                    },
                    buttons: {
                        register: translate("Registreren"),
                        or: translate('of'),
                        google: translate('Inloggen met Google')
                    },
                    login: {
                        label: translate("Heb je al een account?"),
                        button: translate("Log hier in")
                    }
                }                
            },
            banner: {
                title: translate('Waar Strategie en Eenvoud Samenkomen')
            }
        }
    },
    tooltips: {
        topBar: {
            theme: translate(`Schakel om naar $mode modus`),
            locale: translate('Kies een andere taal'),
            navigateBack: translate('Ga naar vorige pagina')
        }
    },
    validation: {
        noTrailingSpacesStart: translate('Er staan spaties aan het begin van de invoer'),
        noTrailingSpacesEnd: translate('Er staan spaties aan het einde van de invoer'),
        minLength: translate('De minimale lengte voor deze invoer is $minLength {karakter|karakters}'),
        maxLength: translate('De maximale lengte voor deze invoer is $maxLength {karakter|karakters}'),
        mustBeChecked: translate('Dit vakje moet aangevinkt zijn'),
        mustBeUnchecked: translate('Dit vakje mag niet aangevinkt zijn'),
        username: translate('De gebruikersnaam heeft niet het juiste formaat'),
        fullName: translate("De volledige naam heeft niet het juiste formaat"),
        email: translate("Het e-mailadres heeft niet het juiste formaat"),
        lowercase: translate("De waarde moet een kleine letter bevatten"),
        uppercase: translate("De waarde moet een hoofdletter bevatten"),
        special: translate("De waarde moet een speciaal teken bevatten"),
        number: translate("De waarde moet een numeriek teken bevatten")
    }
}

export default nl_nl